module.exports = __webpack_public_path__ + "static/media/meteringcase01.dfd7cc23.png";